import React from 'react';

import { IEditorProps } from '../Editor';
import { LegacyEditor } from './LegacyEditor';
// import './TextMergeFieldSelectorEditor.less'

interface ITextMergeFieldSelectorEditorProps extends IEditorProps {}

/**
 * Legacy rendering hook with specific HTML for TextMergeFieldSelectorEditor
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function TextMergeFieldSelectorEditor(props: ITextMergeFieldSelectorEditorProps) {
  return (
    <LegacyEditor
      {...props}
      content={({ instanceId, targetRef }) => (
        <div className="field-value editor-value-container do-not-override-notification-type">
          <div id={instanceId} ref={targetRef as any} style={{ width: '100%' }}></div>
        </div>
      )}
    />
  );
}
